<form-popup [(visible)]="visible" (save)="onPopupSaveClick()" (visibleChange)="onVisibleChange($event)" titleText="New Supplier">
    <supplier-form [data]=""></supplier-form>
</form-popup>